<script setup lang="ts">
defineProps<{
  name: string
}>()
</script>

<template>
  <div :class="$style.row">
    <dt :class="[$style.row__title, $style.title]">
      <span :class="$style.title__text">
        {{ name }}
      </span>
      <slot name="afterName" />
    </dt>
    <dd :class="$style.row__value">
      <slot v-if="$slots.editor" name="editor" />
      <slot v-else />
    </dd>
    <div
      :class="[$style.row__value, $style['row__value--after']]"
      v-if="$slots.rowAfter"
    >
      <slot name="rowAfter" />
    </div>
  </div>
</template>

<style lang="scss" module>
.row {
  display: grid;
  column-gap: 32px;
  grid-template:
    'title value'
    'tafter vafter'
    / min(200px) 1fr;

  &__title {
    grid-area: title;

    &--after {
      grid-area: tafter;
    }
  }

  &__value {
    grid-area: value;

    &--after {
      grid-area: vafter;
    }
  }
}

.title {
  display: flex;
  align-items: center;

  &__text {
    color: $color-text-and-object-high-emphasis;
    font-size: 16px;
    font-weight: bold;
    line-height: 24px;
  }
}
</style>
